import { gql } from '@apollo/client'
import {
  Docview,
  RecommendedDocuments,
  ViewLockContext,
  ViewLockWrapper,
} from '@jusbrasil-web/docview/core'
import { ServerSidePersistentAlertBanner } from '@jusbrasil-web/shared-persistent-alert-banner'
import { QualtricsScriptLoader } from '@jusbrasil-web/shared-qualtrics-script'

import {
  Comments,
  ModelDocument,
  ModelMetaTags,
  ModelToolbar,
  ModerationBanner,
  PublicationAppbar,
  PublicationHeader,
  PublicationSidebar,
} from '../../components'

export const ModelRoot = gql`
  query modelRoot(
    $docId: NumericID!
    $isNewsPage: Boolean!
    $appPageId: String = "web-docview-model"
  ) {
    root {
      document: documentByNumericID(docId: $docId, artifact: "MODELO_PECA") {
        docId
        url
        slug
        status
        isActive
        hasCreditsToViewDocument: viewerCanUseFeature(featureCode: "view_lr_content_1000")
        canViewLrContent: viewerCanUseFeature(featureCode: "view_lr_content")
        canCopyContent: viewerCanUseFeature(featureCode: "copy_modelos_content")
        readingTime
        boxResourceId

        ...ModelToolbar_document
        ...PublicationHeader_document
        ...PublicationAppbar_document
        ...ModelDocument_document
        ...PublicationSidebar_document
        ...Docview_document
        ...RecommendedDocuments_document
        ...Comments_document
        ...ViewLockContext_document
        ...ViewLockWrapper_document
        ...ModerationBanner_document
        ...ModelMetaTags_document
      }

      viewer: me {
        pid
        boxProfileInfo {
          linkedAccount
        }
        hasPaidPlan
        viewContentBlocked: isBlockedFeature(featureCode: "view_lr_content_1000")

        ...ModelToolbar_viewer
        ...PublicationHeader_viewer
        ...ModelDocument_viewer
        ...Docview_viewer
        ...Comments_viewer
        ...ViewLockContext_viewer
        ...ViewLockWrapper_viewer
        ...ModerationBanner_viewer
        ...QualtricsScriptLoader_viewer
      }
      ...ServerSidePersistentAlertBanner_root
    }
  }

  ${ModelToolbar.fragments.document}
  ${PublicationHeader.fragments.document}
  ${PublicationAppbar.fragments.document}
  ${ModelDocument.fragments.document}
  ${Docview.fragments.document}
  ${PublicationSidebar.fragments.document}
  ${RecommendedDocuments.fragments.document}
  ${Comments.fragments.document}
  ${ViewLockContext.fragments.document}
  ${ViewLockWrapper.fragments.document}
  ${ModerationBanner.fragments.document}
  ${ModelMetaTags.fragments.document}

  ${ModelToolbar.fragments.viewer}
  ${PublicationHeader.fragments.viewer}
  ${ModelDocument.fragments.viewer}
  ${Docview.fragments.viewer}
  ${Comments.fragments.viewer}
  ${ViewLockContext.fragments.viewer}
  ${ViewLockWrapper.fragments.viewer}
  ${ModerationBanner.fragments.viewer}
  ${QualtricsScriptLoader.fragments.viewer}
  ${ServerSidePersistentAlertBanner.fragments.root}
`
